import { FC } from "react";
import { Skeleton, Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import EventForm from "../EventForm";

import { useEventDetails } from "./hooks";

const EventDetails: FC = () => {
  const { form, loading, urls } = useEventDetails();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Event details" />
        </Typography.Title>
      </Header>
      <Space />
      {!loading ? (
        <EventForm {...form} eventUrlIds={urls} />
      ) : (
        <Skeleton paragraph={{ rows: 10 }} />
      )}
    </>
  );
};

export default EventDetails;
